// extracted by mini-css-extract-plugin
export default {"Circle":"FeatureIcon_Circle__tAr9W","Icon":"FeatureIcon_Icon__sM6KH","Missing":"FeatureIcon_Missing__HtZsx"};